<template>
    <div class="plano_modal" v-show="visible">
        <b-card>
            <label> <h3>Edit Grid Step</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Grid Step:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="gridStep"></NumberInput> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

var editGridWidget;
window.editGrid = function editGrid(data, onValidate, onCancel) {
    editGridWidget.gridStep = data.gridStep;
    editGridWidget.visible = true;
    editGridWidget.onValidate = onValidate;
    editGridWidget.onCancel = onCancel;
};

export default {
    components: { NumberInput },
    data() {
        return {
            gridStep: 0,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editGridWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                gridStep: parseFloat(this.gridStep)
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_grid.vue?225662c2